export const veridionPageFI = {
  "seo": {
    "title": "Veridion Agentic Company Intelligence | Tekoälytyöntekijöiden organisaatio",
    "description": "Tuottavuuden seuraava taso: Organisation as a Service. Tekoälytyöntekijöiden organisaatio toimittaa tarkastettua työtä, suunniteltavissa kiinteissä sykleissä, omissa tiloissanne tai omassa pilvessänne."
  },
  "hero": {
    "kicker": "Veridion Agentic Company Intelligence",
    "title": "Yksi luoja, loputtomasti ratkaisuja.",
    "claim": "Tuottavuuden seuraava taso: Organisation as a Service.",
    "lead": "Yritystekoäly, joka ohjaa koko pAIoneer Labs GmbH:ta: tekoälyhenkilöstöstä koostuva työvoima, joka integroituu yrityksenne jokaiseen prosessiin, vie työn itsenäisesti loppuun asti ja oppii jokaisesta tehtävästä. Ihmiset antavat suunnan. Kaikki muu tapahtuu itsestään."
  },
  "vision": {
    "lines": [
      "Ohjelmistot antoivat yrityksille työkalut.",
      "Tekoäly antoi niille avustajat.",
      "Veridion antaa niille organisaation."
    ],
    "note": "Tieto liikkuu tunneissa, kokemus jää eläkkeelle, paikat jäävät täyttämättä. Yksi työkalu lisää ei ratkaise sitä; sen ratkaisee työvoima, jota ei tarvitse palkata."
  },
  "grow": {
    "title": "Minkä se ei osaa, sen se luo",
    "text": "Kun tehtävää varten ei vielä ole kyvykkyyttä tai jokin ei onnistu nykyisillä keinoilla, Veridion kehittää itse uusia, mielivaltaisen monimutkaisia tekoälyjärjestelmiä — tekoäly kehittää tekoälyä eteenpäin: suunniteltuna, rakennettuna, testattuna ja käyttöönotettuna. Vain hyväksyntä pysyy ihmisellä [Intent-Driven Developmentin](idd) (IDD) kautta.",
    "punch": "Juuri sitä se tarkoittaa: yksi luoja, loputtomasti ratkaisuja."
  },
  "integrate": {
    "title": "Keskellä teidän prosessejanne",
    "subtitle": "Ei uutta ohjelmistoa, ei koulutusta, ei järjestelmänvaihtoa.",
    "cards": [
      {
        "title": "Yrityschatissa",
        "text": "Keskustelu käydään siellä, missä väkenne kirjoittaa jo nyt: Webexissä, Microsoft Teamsissa, Zoomissa, Slackissa. Yksi viesti riittää."
      },
      {
        "title": "Työkaluissanne",
        "text": "Projektinhallinta, repositoriot, arkistot: työ tehdään järjestelmissä, jotka ovat jo olemassa, ei niiden ohi."
      },
      {
        "title": "Tarjouksesta kirjanpitoon",
        "text": "Prosessi toisensa jälkeen, omassa tahdissanne. Kun kapasiteetti käy vähiin, myös vain yksittäinen kehityspaketti tai kokonainen projekti."
      }
    ]
  },
  "org": {
    "title": "Työvoima, organisoitu kuin yritys",
    "subtitle": "Emme pakota yhtäkään yritystä jäykkään muottiin: suunnittelemme mille tahansa yritysrakenteelle yksilöllisen organigrammin, määrittelemme selkeät roolit ja vastuualueet ja mukaudumme joustavasti. Jokainen liiketoimintayksikkö koostuu Veridionin orkestroimista tekoälytyöntekijöistä, jotka työskentelevät täysin automatisoidusti [IDD](idd) Human-in-the-Loop -pisteeseen asti — ja jos jokin ei vielä onnistu, Veridion kehittää itse uuden tekoälyn.",
    "execKicker": "Koordinointitaso — täysin automatisoitu IDD Human-in-the-Loop -pisteeseen asti",
    "execTitle": "Yksilöllinen organigrammi, selkeät roolit ja tekoäly, joka kehittää tekoälyä eteenpäin.",
    "execText": "Ihmispäättäjien alapuolella koordinointitaso ja tekoälytyöntekijöistä koostuvat liiketoimintayksiköt toimivat täysin automatisoidusti: ne pilkkovat tavoitteet, jakavat työn selkeästi määriteltyihin rooleihin ja vastuisiin, ratkaisevat ongelmat itsenäisesti ja pyytävät ihmiseltä kohdennetut hyväksynnät. Ihminen loopissa ohjaa [Intent-Driven Developmentin](idd) (IDD) avulla — далеко ohjelmistokoodia laajemmin ihmisen ja tekoälyn yhteisenä ohjauksena aikomusten, päätösten ja tarkistusskenaarioiden kautta. Ja aina kun kyvykkyys puuttuu, Veridion suunnittelee ja rakentaa itsenäisesti uusia, mielivaltaisen monimutkaisia tekoälyjärjestelmiä — tekoäly kehittää tekoälyä.",
    "units": [
      {
        "name": "Ohjelmistokehitys",
        "text": "Vastaa ohjelmistosta vaatimuksesta tuotantoon asti: arkkitehtuuri, koodi, testit, katselmoinnit, putket ja laatu niiden takana."
      },
      {
        "name": "Elektroniikka ja laiteohjelmistot",
        "text": "Vastaa laitteistopuolesta: piirit, laiteohjelmistot ja jokaisen komponentin valinta."
      },
      {
        "name": "Kvanttilaskenta ja kvanttitekoäly",
        "text": "Vastaa kvanttilaskennan ja kvanttitekoälyn tutkimuksesta ja tekee kestävistä tuloksista tuotteita."
      },
      {
        "name": "Myynti ja markkinointi",
        "text": "Vastaa markkinoista: seuraa niitä, löytää kohdeasiakkaat, laatii taustamuistiot, luonnostelee tekstit ja tarjoukset. Kaupan päättää ihminen."
      },
      {
        "name": "Tuotteet ja alustan ylläpito",
        "text": "Vastaa tuotteista ja ylläpidosta: strategia, prioriteetit, julkaisut sekä käynnissä olevan alustan valvonta, häiriöt ja kapasiteetti."
      },
      {
        "name": "Hallinto ja talous",
        "text": "Vastaa kaupallisesta puolesta: tositteet, laskut, sopimukset, määräajat, valmisteltuina allekirjoitusta vaille, ja se jää teille."
      }
    ]
  },
  "trust": {
    "title": "Mihin voitte luottaa",
    "cards": [
      {
        "title": "Human-in-the-Loop & IDD paljon koodia laajempana",
        "text": "Intent-Driven Development ([IDD](idd)) ulottuu paljon ohjelmistokoodia pidemmälle: se on sitä, mitä loopissa oleva ihminen tekee yhdessä tekoälyn kanssa kaikilla yrityksen osa-alueilla. Ihminen ja tekoäly määrittelevät yhdessä tarkoituksen (Intent), tekevät sitovat päätökset (Decisions) ja asettavat todennettavat skenaariot (Scenarios), ennen kuin tekoälyhenkilöstö toteuttaa työn itsenäisesti kiinteissä, suunniteltavissa sykleissä ihmisen hyväksynnällä."
      },
      {
        "title": "Peliteoreettisesti optimoitu viestintä",
        "text": "Projektinhallinta ja tekoälytyöntekijöiden viestintä on optimoitu peliteorialla, yksittäisestä tekoälytyöntekijästä kokonaiseen liiketoimintayksikköön asti: perusteellisuus ja perusteltu vastaväite palkitaan; läpihuutaminen, toisto ja vastuun siirtäminen maksavat. Näin paras viestintä voittaa."
      },
      {
        "title": "Selitettävä lähteeseen asti",
        "text": "Explainable AI on täällä työperiaate, ei lisäosa: jokainen tulos tuo avoimesti esiin, mistä se on syntynyt, kohdat yrityksen tietämyksessä, datan, laskentapolun. Mille ei ole näyttöä, sitä ei väitetä."
      },
      {
        "title": "Oppii itsenäisesti",
        "text": "Omat tunnusluvut luetaan jokaisen kierroksen jälkeen ja omia sääntöjä mukautetaan sen mukaan: jokainen käynnissä oleva projekti tekee kokonaisuudesta paremman."
      }
    ]
  },
  "daily": {
    "title": "Mitä hoidetaan jo tänään",
    "subtitle": "Joka päivä, läpi koko yrityksen.",
    "items": [
      {
        "title": "Kehitys",
        "text": "Koodi, testit ja dokumentaatio kirjatuista päätöksistä. Vuosien mittaan kasvaneen ohjelmiston uudistaminen golden master- ja back-to-back-todistein."
      },
      {
        "title": "Elektroniikka ja laiteohjelmistot",
        "text": "Datalehtien analysointi, piirien simulointi digitaalisina kaksosina, laiteohjelmistojen kehitys ja komponenttivaihtoehtojen arviointi, ennen kuin mitään valmistetaan, laitteistonläheisesti anturiin asti."
      },
      {
        "title": "Kvanttitutkimus",
        "text": "Tekniikan uusimman tason lukeminen, toistettavien kokeiden rakentaminen ja arviointi klassisia vertailukohtia vasten, jokainen tulos kirjattuna jäljitettävästi."
      },
      {
        "title": "Data-analyysi",
        "text": "SQL Server, MariaDB, MySQL ja Oracle: tyypitetty analyysisuunnitelma, yksinomaan lukevat kyselyt, tilastot ajoympäristöstä, raportit yhdestä versioidusta tuloksesta."
      },
      {
        "title": "Hallinto ja talous",
        "text": "Kirjanpito, laskentatoimi ja yhtiön byrokratia: tositteiden luku, luokittelu ja arkistointi; mukana laskujen ja sopimusten luonnokset."
      },
      {
        "title": "Projektit ja tehtävät",
        "text": "Kokouksen transkriptiosta tulee ilman välivaiheita tehtäviä projektinhallintaan, ja edistyminen virtaa takaisin: seuraava kokous alkaa ajantasaisesta tilanteesta."
      },
      {
        "title": "Yrityksen tietämys",
        "text": "Tietämyskanta asiakirjoille ja graafitietokanta, joka kytkee tehtävät, päätökset, henkilöt ja järjestelmät toisiinsa: asiayhteys viikkojen ja projektirajojen yli."
      },
      {
        "title": "Tiedonhaku internetistä",
        "text": "Mitä yrityksen tietämyksestä ei löydy, se selvitetään: haetaan, luetaan parhaat sivut, ja lopussa on raportti, jossa jokaisella väitteellä on numeroitu lähteensä."
      },
      {
        "title": "Puhe ja kokoukset",
        "text": "Koko yritystä voi johtaa mobiilisti: puhutut keskustelut tekevät saman työn kuin chat, myös matkalla puhelimella."
      },
      {
        "title": "Toimistotyö RoBuddyn kanssa",
        "text": "RoBuddy kattaa työpisteen: tapaamiset, sähköpostit, koulutukset ja tietosuojakysymykset. Yksiköt kattavat muun yrityksen."
      }
    ]
  },
  "operate": {
    "title": "Käyttö",
    "cards": [
      {
        "title": "Omissa tiloissanne tai omassa pilvessänne",
        "text": "Etukäteen laskemme yhdessä, mitkä prosessit kannattavat: sijoitetun pääoman tuotto ja kokonaiskustannukset ovat avoimesti esillä. Käyttö tapahtuu omalla laitteistollanne tai omassa pilvessänne, eikä yksikään asiakirja poistu talosta."
      },
      {
        "title": "Meillä",
        "text": "pAIoneer Labs GmbH on rakennettu näin alusta asti: projektimme, yritystietämyksemme ja hallintomme kulkevat sen kautta. Organisaatio kehittää alustamme [kaupankäyntiavustajan](finance) itse ja on sen chatin tekoäly."
      }
    ]
  },
  "cta": {
    "title": "Yhteydenotto",
    "subtitle": "Palvelinohjelmistona infrastruktuurissanne. Hinnan kerromme pyynnöstä.",
    "button": "Lähetä yhteydenotto",
    "subject": "Veridion Agentic Company Intelligence"
  }
};
